import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ログインの自動延長【2026-11-04】
//   サーバーは使っているあいだ、古くなったトークンの代わりを応答のヘッダー X-New-Token で返す。
//   画面ごとにトークンを付けて fetch しているので、ここで fetch を包んで1か所で受け取る。
//   送ったトークンが今のものと同じときだけ差し替える（別のタブでログインし直した後に、古い応答で戻さない）。
(function keepTokenFresh() {
  if (typeof window === 'undefined' || !window.fetch || window.fetch.__nekotamWrapped) return;
  const orig = window.fetch.bind(window);
  const wrapped = async (input, init) => {
    const res = await orig(input, init);
    try {
      const fresh = res.headers && res.headers.get('X-New-Token');
      if (fresh) {
        const h = (init && init.headers) || (input && input.headers) || {};
        const sent = typeof h.get === 'function' ? h.get('Authorization') : (h.Authorization || h.authorization);
        const cur = localStorage.getItem('token');
        if (cur && sent === 'Bearer ' + cur) localStorage.setItem('token', fresh);
      }
    } catch (_) { /* 差し替えられなくても、前のトークンは期限まで使える */ }
    return res;
  };
  wrapped.__nekotamWrapped = true;
  window.fetch = wrapped;
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
